import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M20 0C12.07 0 5.22 4.614 1.985 11.304h36.03C34.781 4.614 27.93 0 20 0Zm0 40c7.93 0 14.78-4.614 18.016-11.304H1.985C5.22 35.386 12.07 40 20 40Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m25.978 20-2.443 1.149 1.3 2.366-2.652-.508-.336 2.68L20 23.715l-1.848 1.97-.336-2.679-2.652.508 1.3-2.366L14.023 20l2.443-1.149-1.3-2.365 2.651.507.337-2.68L20 16.285l1.848-1.97.335 2.679 2.653-.507-1.3 2.365L25.977 20Z"
}, null, -1), i = [
  o,
  c,
  s
];
function r(d, _) {
  return e(), l("svg", n, [...i]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
